export default function initAnnualReport () {

	const annualReport = document.querySelectorAll('.annual-report');
	if (!annualReport.length) return;

	let isMobile = window.innerWidth <= 1000;

	let browserHeight = window.innerHeight|| document.documentElement.clientHeight|| document.body.clientHeight;
	const navMenuHeight = 660; // annual-report.scss -> .annual-report__navigation-list -> 665px
	const navMenu = document.querySelector('.annual-report__navigation-space');

	function navMenuHeightFunc () {
		if (!isMobile && browserHeight < navMenuHeight) {
			navMenu.classList.add('annual-report__navigation-space__scroll');
		} else if (isMobile && browserHeight < navMenuHeight * 2) {
			navMenu.classList.add('annual-report__navigation-space__scroll');
		}
	}

	navMenuHeightFunc()

	const body = document.querySelector('body');
	let menuOpened = false;
	const clickMenu = document.querySelector('.annual-report__burger-open');
	const closeMenuDesktop = document.querySelector('.annual-report__burger-close__desktop');
	const closeMenuMobile = document.querySelector('.annual-report__burger-close__mobile');
	const closeMenuAll = document.querySelectorAll('.annual-report__burger-close');
	const screenOverlay = document.querySelector('.annual-report__overlay');
	const navigation = document.querySelector('.annual-report__navigation');
	const navigationItem =  document.querySelectorAll('.annual-report__navigation-item');
	const logo = document.querySelector('.annual-report__logo')

	screenOverlay.style.display = 'none';
	navigation.style.display = 'none';
	closeMenuDesktop.style.display = 'none';
	closeMenuMobile.style.display = 'none';

	logo.addEventListener('click', () => {
		closeMenuFunc();
	});

	window.addEventListener('mouseup', function(event) {
		if (navigation.style.display === 'block') {
			if (event.target !== navMenu) {
				closeMenuFunc();
			}
		}
	});

	window.addEventListener('keydown', function(event) {
		if (navigation.style.display === 'block') {
			if(event.key === "Escape") {
				closeMenuFunc();
			}
		}
	});

	clickMenu.addEventListener('click', () => {
		if (!menuOpened) {
			body.classList.add('annual-report__scroll-stop');
			navigation.style.display = 'block';
			if (!isMobile) {
				screenOverlay.style.display = 'block';
				closeMenuMobile.style.display = 'block';
			} else {
				closeMenuDesktop.style.display = 'block';
				navigation.style.position = 'fixed';
			}
			navigation.style.display = 'block';
			menuOpened = true;
		} else {
			closeMenuFunc();
		}
	});

	function closeMenuFunc () {
		navMenu.scrollTo({top: 0});
		body.classList.remove('annual-report__scroll-stop')
		screenOverlay.style.display = 'none';
		navigation.style.display = 'none';
		closeMenuDesktop.style.display = 'none';
		closeMenuMobile.style.display = 'none';
		menuOpened = false;
	}

	closeMenuAll.forEach( el => {
		el.addEventListener('click', () => {
			closeMenuFunc();
		});
	});

	//click on menu element
	navigationItem.forEach(el => {
		el.addEventListener('click', () => {
			closeMenuFunc();
		});
	});

	let clientHeightStart = window.innerHeight|| document.documentElement.clientHeight|| document.body.clientHeight;

	window.addEventListener('resize', function() {
		let resizedHeight = window.innerHeight|| document.documentElement.clientHeight|| document.body.clientHeight;
		if (clientHeightStart !== resizedHeight) {
			clientHeightStart = resizedHeight;
			return;
		}
		isMobile = window.innerWidth <= 1000;
		browserHeight = window.innerHeight|| document.documentElement.clientHeight|| document.body.clientHeight;
		closeMenuFunc();
		navMenuHeightFunc();
	}, true);

	const minicardsTextHolder = document.querySelectorAll('.annual-report__minicards-list');
	const minicardsButtons = document.querySelectorAll('.annual-report__minicards-more');

	minicardsButtons.forEach( el => {
		if (isMobile) {
			el.style.display = 'block';
		}
	});

	minicardsTextHolder.forEach(el => {

		let sectionTextItems = el.querySelectorAll('.annual-report__minicards-item');
		let count = 0;
		sectionTextItems.forEach(el => {
			if (isMobile) {
				if (count > 2) {
					el.style.display = 'none';
				}
				count++;
			}
		})
	});

	minicardsButtons.forEach(el => {
		el.addEventListener('click', () => {
			let sectionTextItems = el.parentNode.querySelectorAll('.annual-report__minicards-item');
			sectionTextItems.forEach(el => {
				el.style.display = 'block';
			});
			el.remove();

		})
	});

	const sectionTextHolder = document.querySelectorAll('.annual-report__section-col');
	const showMoreButtons = document.querySelectorAll('.annual-report__section-read-more');

	showMoreButtons.forEach( el => {
		if (isMobile) {
			el.style.display = 'block';
		}
	});

	sectionTextHolder.forEach(el => {

		let sectionTextItems = el.querySelectorAll('.annual-report__section-col__item');
		let count = 0;
		sectionTextItems.forEach(el => {
			if (isMobile) {
				if (count > 0) {
					el.style.display = 'none';
				}
				count++;
			}
		})
	});

	showMoreButtons.forEach(el => {
		el.addEventListener('click', () => {
			let sectionTextItems = el.parentNode.querySelectorAll('.annual-report__section-col__item');
			sectionTextItems.forEach(el => {
				el.style.display = 'block';
			});
			el.remove();

		})
	});

	// const minicardMore = document.querySelectorAll('.annual-report__section-minicard__more');
	const minicardMoreBlock = document.querySelectorAll('.annual-report__section-minicard__item');

	minicardMoreBlock.forEach(el => {
		let minicardMoreText = el.parentNode.querySelector('.annual-report__section-minicard__details')
		if (window.innerWidth > 1000) {
			minicardMoreText.style.display = 'block';
		} else {
			minicardMoreText.style.display = 'none';
		}

		el.addEventListener('click', () => {
			if (isMobile) {
				if (minicardMoreText.style.display === 'none') {
					el.querySelector('.annual-report__section-minicard__more').classList.add('annual-report__section-minicard__more_opened');
					el.querySelector('.annual-report__section-minicard__more').classList.remove('annual-report__section-minicard__more_closed');
					minicardMoreText.style.display = 'block';
				} else if (minicardMoreText.style.display === 'block') {
					el.querySelector('.annual-report__section-minicard__more').classList.add('annual-report__section-minicard__more_closed');
					el.querySelector('.annual-report__section-minicard__more').classList.remove('annual-report__section-minicard__more_opened');
					minicardMoreText.style.display = 'none';
				}
			}
		});
	});

	let blackBlocks = [
		'factoid-banner-mortgage',
		'factoid-graph-remote-banking',
		'factoid-graph-site',
		'factoid-banner-rent',
		'factoid-banner-digital',
		'factoid-banner-realty',
		'factoid-banner-project',
		'factoid-banner-securitization',
		'factoid-table-system-monitoring',
		'factoid-table-system-sharebuilding',
		'factoid-table-system-support',
		'factoid-table-system-portal',
		'factoid-table-system-eiszh',
		'factoid-table-system-superservice',
		'factoid-table-system-modeling',
		'factoid-table-system-commercial',
		'factoid-graph-development',
		'factoid-banner-strategics',
		'factoid-banner-techsupport',
		'factoid-static__coworking',
		'factoid-image__masterchain-top',
		'factoid-image__masterchain-bottom',
		'factoid-banner-technology',
	];

	for ( let i = 0; i < blackBlocks.length; i++ ) {
		initScrollBar(blackBlocks[i]);
	}
}

function initScrollBar (block) {
	const scrollBarProgress = document.querySelector('.annual-report__section-' + block + '__wrapper-scroll__progress')
	const scrollContainer = document.querySelector('.annual-report__section-' + block + '__wrapper');
	scrollContainer.addEventListener('scroll', function () {
		let scrollLeft = scrollContainer.scrollLeft;
		let scrollWidth = scrollContainer.scrollWidth;
		let percent = scrollLeft / (scrollWidth - scrollContainer.clientWidth) * 67;
		scrollBarProgress.style.left = percent + '%';

	}, { passive: true });
}

